import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import type { SupportedLanguageCode } from "../language";
import { getPath } from "../url";
import { useLayout } from "./useLayout";
import { useTypedLocation } from "./useTypedLocation";

export function useNavigateToNewLanguage() {
  const navigate = useNavigate();
  const typedLocation = useTypedLocation();
  const layout = useLayout();
  const isDesktop = layout === "desktop";
  const { originCanonical, destinationCanonical } = useParams();

  const navigateToNewLanguage = useCallback(
    (language: SupportedLanguageCode) => {
      if (isDesktop) {
        // eslint-disable-next-line no-restricted-globals
        location.reload(); // This reloads the page completely to re-render the localized map
        return;
      }

      navigate(
        {
          pathname: getPath(originCanonical, destinationCanonical, language),
          hash: typedLocation.hash,
          search: typedLocation.search,
        },
        {
          state: {
            ...typedLocation.state,
            preferencesScreen: "main",
          },
        },
      );
    },
    [
      isDesktop,
      navigate,
      originCanonical,
      destinationCanonical,
      typedLocation.hash,
      typedLocation.search,
      typedLocation.state,
    ],
  );

  return { navigateToNewLanguage };
}
